const show = (el) => {
  el.removeAttribute("aria-hidden");
  el.querySelectorAll("a, button").forEach((el) => {
    el.tabIndex = null;
  });
};

const hide = (el) => {
  el.setAttribute("aria-hidden", "true");
  el.querySelectorAll("a, button, input").forEach((el) => {
    el.tabIndex = -1;
  });
};

class SubcollectionCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        slidesPerView: "auto",
        watchSlidesProgress: true,
        navigation: {
          nextEl: this.querySelector("[data-subcollection-navigation-next]"),
          prevEl: this.querySelector(
            "[data-subcollection-navigation-previous]",
          ),
        },
        on: {
          lock: () => {
            this.classList.add(
              "subcollections__subcollection-carousel-wrapper--locked",
            );
          },
          unlock: () => {
            this.classList.remove(
              "subcollections__subcollection-carousel-wrapper--locked",
            );
          },
          slideChangeTransitionStart: () => {
            this.swiper.slides.forEach((slide) => {
              hide(slide);
            });
          },
          slideChangeTransitionEnd: () => {
            window.requestAnimationFrame(() => {
              this.swiper.slides.forEach((slide) => {
                console.log(`slide`, slide);
                slide.classList.contains("swiper-slide-visible")
                  ? show(slide)
                  : hide(slide);
              });
            });
          },
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);

      this.swiper.slides.forEach((slide) => {
        slide.classList.contains("swiper-slide-visible")
          ? show(slide)
          : hide(slide);
      });
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("subcollection-carousel")) {
  customElements.define("subcollection-carousel", SubcollectionCarousel);
}
